import { postJson, fetchJson } from 'utils/fetch';

export const getFilteredUsers = (role, tags) =>
  postJson('/users/diffusion.json', {
    role: role === 'none' ? null : role,
    tags,
  });

export const fetchTags = () => fetchJson('/users/tags.json');



// WEBPACK FOOTER //
// ./src/modules/diffusion/api/index.js